import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../../../assets/css/pages/stores/change-request-approved.css';
import SelectSearch from '../../common/SelectSearch';
import ReactCalender from '../../common/Datepicker';
import Card from '../../common/Card';
import Input from '../../common/Input';
import Button from '../../common/Button';
import Modal from '../../common/Modal';
import Label from '../../common/Label';
import Pagination from '../../common/Pagination';
import { useDispatch, useSelector } from 'react-redux';
import {
    fetchCompetitorChains,
    fetchCompetitorChainsByStoreCode,
    fetchCompetitorStores,
    fetchCompetitorStoresByStoreCode,
    fetchDepartments,
    fetchSources,
    fetchStores,
    setLoader,
} from '../../../redux/actions/api';
import { createCompetitorChainOptions, createCompetitorStoreMultiOptions, createStoreOptions } from '../../../utils/helpers/option';
import EditTable from '../../tables/EditTable';
import { getTableChangeRequestApproved, getTableFreshnessChangeRequestApproved } from '../../tables/table';
import { ChangeRequestControllerService, ConstantsControllerService, ErrorMessage, PriceSearchRequest } from '../../../services';
import { setToastsError, setToastsSuccess, setToastsWarning } from '../../../redux/actions/common';
import Choice from '../../common/Choice';
import apiErrorHandler, { getErrorItems } from '../../../api/apiErrorHandler';
import { setDeleteConfirm, setIsDeleteContinue } from '../../../redux/actions/modal';
import { useLocation } from 'react-router-dom';
import { clearErrors } from '../../../redux/actions/error';
import MultiSelect from '../../common/MultiSelect';
import { getDateTwoWeeksLater, isPastDate } from '../../../utils/helpers/date';
import { setChangeRequestType } from '../../../redux/actions/storage';
import { getDeviationRates } from '../../../utils/helpers/formula';
import { isLegacy } from '../../../utils/helpers/common';
import { isInvalidJan } from '../../../utils/helpers/validation';
import { EitherOneRequiredText } from '../../common/RequiredBadge';
import DuplicateModal from '../../modals/DuplicateModal';

const DEFAULT_STATE = {
    departments: [],
    lines: [],
    classes: [],
    subclasses: [],

    storeCode: '',
    jan: '',
    startDate: '',
    endDate: '',
    selectedDepartment: null,
    selectedLine: null,
    selectedClass: null,
    selectedSubclass: null,
    competitorChainCode: [],
    competitorStoreCode: [],
    competitorChainCodes: [],
    competitorStoreCodes: [],
    selectedData: [],

    selectedSource: '',
    selectedStartDate: '',
    selectedEndDate: '',
    authorizerName: '',

    isShowPleaseSelect: false,
    isShowPleaseDeleteSelect: false,
    isShowModalApprove: false,
    isSearched: false,
    isInstructionSelect: false,
    isDelete: false,
    isLoad: false,

    paginate: new Date(),

    page: 1,
    limit: 30,
    apiResponse: null,

    // 重複確認モーダル
    duplicateModalIsShow: false,
    duplicateModalProps: null,
};

const ChangeRequestApproved = (props) => {
    const { type } = props;
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const location = useLocation();

    const sort = useSelector((state) => state.sort);

    const constants = useSelector((state) => state.constants);
    const { departments, competitorChains, competitorStores, sources, stores } = constants;

    const storage = useSelector((state) => state.storage);
    const { changeRequestType, isFreshness, isCompetitor, isInstruction, isHeadquarter, isHead } = storage;

    const modal = useSelector((state) => state.modal);
    const { isDeleteContinue } = modal;

    const [state, setState] = useState(DEFAULT_STATE);

    const {
        lines,
        classes,
        subclasses,

        storeCode,
        jan,
        startDate,
        endDate,
        selectedDepartment,
        selectedLine,
        selectedClass,
        selectedSubclass,
        competitorChainCode,
        competitorStoreCode,
        competitorChainCodes,
        competitorStoreCodes,
        selectedData,

        selectedSource,
        selectedStartDate,
        selectedEndDate,
        authorizerName,

        isShowPleaseSelect,
        isShowPleaseDeleteSelect,
        isShowModalApprove,
        isSearched,
        isInstructionSelect,
        isDelete,
        isLoad,

        paginate,

        page,
        limit,
        apiResponse,

        duplicateModalIsShow,
        duplicateModalProps,
    } = state;

    // 継続登録開始日・終了日のmin/max
    const now = new Date();
    const minStartDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const maxStartDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 2); // 2日後の日付を取得
    const minEndDate = new Date(selectedStartDate);
    const maxEndDate = new Date(getDateTwoWeeksLater(selectedStartDate)); // 2週間後の日付を取得

    const [isFirstLoad, setIsFirstLoad] = useState(true);

    useEffect(() => {
        setState(DEFAULT_STATE);
        dispatch(clearErrors());
        dispatch(fetchDepartments());
        dispatch(fetchSources());
        dispatch(fetchStores());
        if (isHeadquarter) {
            dispatch(fetchCompetitorChains());
            dispatch(fetchCompetitorStores());
            dispatch(setChangeRequestType(type));
        } else {
            dispatch(fetchCompetitorChainsByStoreCode());
            dispatch(fetchCompetitorStoresByStoreCode());
        }
    }, [dispatch, location]);

    useEffect(() => {
        if (isFirstLoad) {
            setIsFirstLoad(false);
            return;
        }
        getChangeRequestsApproved(page);
    }, [sort]);

    useEffect(() => {
        if (isDeleteContinue) {
            dispatch(setIsDeleteContinue(false));
            handleSubmitModalDelete();
        }
    }, [isDeleteContinue]);

    // 部門が変更された場合
    useEffect(() => {
        // ライン名、クラス名、サブクラス名をクリア
        setState((prevState) => ({
            ...prevState,

            lines: [],
            selectedLine: null,

            classes: [],
            selectedClass: null,

            subClasses: [],
            selectedSubclass: null,
        }));

        // 部門が選択されている場合のみ
        if (selectedDepartment) {
            (async () => {
                try {
                    // ライン一覧を取得
                    const response = await ConstantsControllerService.getLines([selectedDepartment.value]);
                    const lines = response.map((item) => ({
                        value: item.lineCode,
                        label: item.divisionName,
                    }));
                    handleChangeState('lines', lines);
                } catch (error) {
                    apiErrorHandler(dispatch, error);
                }
            })();
        }
    }, [dispatch, selectedDepartment]);

    // ライン名が変更された場合
    useEffect(() => {
        // クラス名、サブクラス名をクリア
        setState((prevState) => ({
            ...prevState,

            classes: [],
            selectedClass: null,

            subClasses: [],
            selectedSubclass: null,
        }));

        // ライン名が選択されている場合のみ
        if (selectedLine) {
            (async () => {
                try {
                    // クラス一覧を取得
                    const response = await ConstantsControllerService.geClasses(selectedLine.value);
                    const classes = response.map((item) => ({
                        value: item.classCode,
                        label: item.divisionName,
                        lineCode: item.lineCode,
                    }));
                    handleChangeState('classes', classes);
                } catch (error) {
                    apiErrorHandler(dispatch, error);
                }
            })();
        }
    }, [dispatch, selectedLine]);

    // クラス名が変更された場合
    useEffect(() => {
        // サブクラス名をクリア
        // API の呼び出しに時間がかかるため先にクリアしておく
        setState((prevState) => ({
            ...prevState,

            subClasses: [],
            selectedSubclass: null,
        }));

        // クラス名が選択されている場合のみ
        if (selectedClass) {
            (async () => {
                try {
                    // サブクラス一覧を取得
                    const response = await ConstantsControllerService.geSubclasses(selectedClass.lineCode, selectedClass.value);
                    const subclasses = response.map((item) => ({
                        value: item.subclassCode,
                        label: item.divisionName,
                    }));
                    handleChangeState('subclasses', subclasses);
                } catch (error) {
                    apiErrorHandler(dispatch, error);
                }
            })();
        }
    }, [dispatch, selectedClass]);

    const table = isFreshness
        ? getTableFreshnessChangeRequestApproved(t, isHeadquarter)
        : getTableChangeRequestApproved(t, isHeadquarter, isInstruction);

    const handleChangeState = (field, value) => {
        setState((prevState) => ({
            ...prevState,
            [field]: value,
        }));
    };

    const handleChangeMultiState = (field, option = []) => {
        setState((prevState) => ({
            ...prevState,
            [field]: option,
        }));
    };

    const handleChainChange = (option, values) => {
        const newCompetitorStoreCode = competitorStoreCode?.filter((store) => values.some((value) => store.value.startsWith(value)));

        const newCompetitorStoreCodes = competitorStoreCodes?.filter((store) => values.some((value) => store.startsWith(value)));

        handleChangeMultiState('competitorStoreCode', newCompetitorStoreCode);
        handleChangeMultiState('competitorStoreCodes', newCompetitorStoreCodes);
    };

    const filteredChildOptions = competitorChainCode ? createCompetitorStoreMultiOptions(competitorStores, competitorChainCodes) : [];

    const handleCloseModal = () => {
        setState((prevState) => ({
            ...prevState,
            isShowPleaseSelect: false,
            isShowPleaseDeleteSelect: false,
            isInstructionSelect: false,
        }));
    };

    const handleContinuationRegister = () => {
        if (selectedData.length === 0) {
            setState((prevState) => ({
                ...prevState,
                isShowPleaseSelect: true,
            }));
        } else {
            if (selectedData.some((item) => item.competitorStoreCode === '99999999')) {
                setState((prevState) => ({
                    ...prevState,
                    isInstructionSelect: true,
                }));
            } else {
                setState((prevState) => ({
                    ...prevState,
                    isShowModalApprove: true,
                }));
            }
        }
    };

    const handleDelete = () => {
        if (selectedData.length === 0) {
            setState((prevState) => ({
                ...prevState,
                isShowPleaseDeleteSelect: true,
            }));
        } else if (selectedData.some((item) => isLegacy(item))) {
            dispatch(setToastsError('店舗メニューから削除してください。'));
        } else {
            dispatch(setDeleteConfirm(true));
        }
    };

    const handlePageClick = (event) => {
        const pageNumber = event.selected + 1;
        getChangeRequestsApproved(pageNumber);
    };

    const handleClear = () => {
        setState((prevState) => ({
            ...prevState,
            lines: [],
            classes: [],
            subclasses: [],
            jan: '',
            startDate: '',
            endDate: '',
            storeCode: '',
            selectedDepartment: null,
            selectedLine: null,
            selectedClass: null,
            selectedSubclass: null,
            competitorChainCode: [],
            competitorStoreCode: [],
            competitorChainCodes: [],
            competitorStoreCodes: [],
        }));
    };

    const handleSetSelectedData = () => {
        if (apiResponse) {
            const displayData = apiResponse.data;
            setState((prevState) => {
                const newData = [
                    ...prevState.selectedData.filter(
                        (item) =>
                            !displayData.some((newItem) => newItem.tokubaiProjectCode === item.tokubaiProjectCode && !newItem.selected),
                    ),
                    ...displayData.filter(
                        (newItem) =>
                            newItem.selected &&
                            !prevState.selectedData.some((item) => item.tokubaiProjectCode === newItem.tokubaiProjectCode),
                    ),
                ];

                return {
                    ...prevState,
                    selectedData: newData,
                };
            });
        }
    };

    const getChangeRequestsApproved = (pageNumber) => {
        // JANに数字以外が含まれていないか確認
        if (isInvalidJan(jan)) {
            dispatch(setToastsError(t('message.error.jan')));
            return;
        }
        dispatch(setLoader(true));
        dispatch(clearErrors());
        handleChangeState('page', pageNumber);
        const isChanged = () => {
            const values = [jan, startDate, endDate, storeCode, selectedDepartment, selectedLine, selectedClass, selectedSubclass];
            const arrays = [competitorChainCode, competitorStoreCode];
            return values.some((value) => value !== '' && value !== null) || arrays.some((value) => value.length !== 0);
        };

        // 検索条件が入力されているか確認
        if (isChanged()) {
            handleChangeState('isSearched', true);
        } else {
            handleChangeState('isSearched', false);
        }

        // 検索
        ChangeRequestControllerService.getChangeRequestsApproved({
            changeRequestType: type ?? changeRequestType,
            departmentCode: selectedDepartment ? selectedDepartment.value : null,
            lineCode: selectedLine ? selectedLine.value : null,
            classCode: selectedClass ? selectedClass.value : null,
            subclassCode: selectedSubclass ? selectedSubclass.value : null,
            storeCode: storeCode ? storeCode : null,
            jan: jan ? jan : null,
            startDate: startDate ? startDate : null,
            endDate: endDate ? endDate : null,
            competitorChainCodes: competitorChainCodes.length === 0 ? null : competitorChainCodes,
            competitorStoreCodes: competitorStoreCodes.length === 0 ? null : competitorStoreCodes,
            page: pageNumber,
            limit: limit,
            sortField: table.heads.find((head) => head.field === sort.sortField)?.field,
            sortType: table.heads.find((head) => head.field === sort.sortField)?.field ? sort.sortType : null,
        })
            .then(async (response) => {
                const responseData = response.data?.map((item) => ({
                    ...item,
                    selected: selectedData.some((dataItem) => dataItem.tokubaiProjectCode === item.tokubaiProjectCode),
                    status: isLegacy(item) ? t('table.legacy_status') : item.status,
                }));

                setState((prevState) => ({
                    ...prevState,
                    apiResponse: { ...response, data: responseData },
                }));
                await getPromiseResult(response.data);
            })
            .catch((error) => {
                apiErrorHandler(dispatch, error);
            })
            .finally(() => {
                handleChangeState('paginate', new Date());
                dispatch(setLoader(false));
            });
    };

    const [discounts, setDiscounts] = useState([]);
    const getPromiseResult = async (responseData) => {
        const data = await discountCheck(responseData);
        setDiscounts(data);
    };

    const discountCheck = async (items) => {
        if (!items) {
            return [];
        }
        try {
            const responses = await getDeviationRates(dispatch, items);
            const results = await Promise.all(
                responses.map(async (item) => {
                    // CMP-1604: 原価割れ判断が不十分なため一時的に削除
                    // if (item.requestSellingPrice < item.costPrice) {
                    //     return 'belowCost';
                    // }

                    const deviationRate = item.deviationRate;

                    if (deviationRate >= 30) {
                        return '30%';
                    }

                    if (deviationRate >= 10) {
                        return '10%';
                    }
                    return '';
                }),
            );

            return results;
        } catch (error) {}
    };

    const handleCloseModalApprove = () => {
        setState((prevState) => ({
            ...prevState,
            isShowModalApprove: false,
            selectedSource: '',
            selectedStartDate: '',
            selectedEndDate: '',
            authorizerName: '',
        }));
    };

    const handleSubmitModalApprove = () => {
        dispatch(clearErrors());
        if (validateFormInput()) return;

        // 本部の場合
        if (isHead) {
            // 継続登録処理を行う
            // ※ 重複チェックは行わない
            createContinuation();
        }
        // 店舗の場合
        else {
            // 重複チェック
            duplicateCheck();
        }
    };

    // 重複チェック
    const duplicateCheck = async () => {
        try {
            dispatch(setLoader(true));

            // 重複チェックAPIを呼ぶ
            const responseData = await ChangeRequestControllerService.checkDuplicateChangeRequest(
                PriceSearchRequest.changeRequestType.COMPETITOR,
                selectedData.map((item) => ({
                    jan: item.jan,
                    competitorStoreCode: isCompetitor ? item.competitorStoreCode : null,
                    discountedRequestSellingPrice: item.discountedRequestSellingPrice,
                    salesStartDate: selectedStartDate,
                    salesEndDate: selectedEndDate,
                })),
            );

            dispatch(setLoader(false));

            // チェック結果を取得
            const duplicateItems = getErrorItems(responseData, selectedData, ErrorMessage.errorType.DUPLICATE);

            // 重複が0件の場合
            if (!duplicateItems.length) {
                // 継続登録処理を行う
                createContinuation();
            }
            // 重複が1件以上の場合
            else {
                const close = () => {
                    setState((prevState) => ({
                        ...prevState,

                        duplicateModalIsShow: false,
                        duplicateModalProps: null,
                    }));
                };

                // 重複確認モーダルを開く
                setState((prevState) => ({
                    ...prevState,

                    duplicateModalIsShow: true,
                    duplicateModalProps: {
                        dataTable: duplicateItems,
                        isFreshness: isFreshness,
                        isContinuation: true,

                        // 「OK」ボタンが押された
                        onOk: () => {
                            // 重複確認モーダルを閉じる
                            close();

                            // 継続登録処理を行う
                            createContinuation();
                        },

                        // モーダルを閉じた or 「キャンセル」ボタンが押された
                        onClose: () => {
                            // 重複確認モーダルを閉じる
                            close();
                        },
                    },
                }));
            }
        } catch (error) {
            dispatch(setLoader(false));
            apiErrorHandler(dispatch, error);
        }
    };

    // 継続登録処理
    const createContinuation = () => {
        dispatch(setLoader(true));
        ChangeRequestControllerService.createChangeRequestContinuation({
            changeRequestType: changeRequestType,
            source: selectedSource,
            salesStartDate: selectedStartDate,
            salesEndDate: selectedEndDate,
            authorizerName: authorizerName,
            items: selectedData.map((item) => {
                return {
                    jan: item.jan,
                    discountedRequestSellingPrice: item.discountedRequestSellingPrice,
                    competitorStoreCode: item.competitorStoreCode,
                    storeCode: item.storeCode,
                    tokubaiProjectCode: item.tokubaiProjectCode,
                };
            }),
        })
            .then(() => {
                dispatch(setToastsSuccess('継続登録が完了しました。'));
                handleCloseModalApprove();
            })
            .catch((error) => {
                apiErrorHandler(dispatch, error, '時間をおいて申請画面をご確認ください。');
            })
            .finally(() => {
                dispatch(setLoader(false));
            });
    };

    const handleSubmitModalDelete = () => {
        // 期限切れ(終了日<本日)の売価は削除対象から除外する
        const validData = selectedData.filter((item) => !isPastDate(item.endDate));
        const hasExpired = validData.length !== selectedData.length;

        if (validData.length === 0) {
            // 全件期限切れの場合は削除APIを呼ばず、選択(チェックボックス)を解除してトーストのみ表示する
            setState((prevState) => ({
                ...prevState,
                // 表示中ページ以外の選択も解除するためselectedDataもクリアする
                selectedData: [],
                apiResponse: {
                    ...prevState.apiResponse,
                    data: prevState.apiResponse.data.map((item) => ({ ...item, selected: false })),
                },
            }));
            dispatch(setToastsWarning('期限切れの売価以外が削除されました。'));
            return;
        }

        dispatch(setLoader(true));
        dispatch(clearErrors());
        handleChangeState('isDelete', true);

        const deleteRequest = isHeadquarter
            ? ChangeRequestControllerService.deleteApprovedChangeRequestForHeadquarter({
                  storeCode: validData[0].storeCode,
                  tokubaiProjectCodeAndSalesStartDateRequests: validData.map((item) => {
                      return {
                          tokubaiProjectCode: item.tokubaiProjectCode,
                          salesStartDate: item.startDate,
                      };
                  }),
              })
            : ChangeRequestControllerService.deleteApprovedChangeRequest({
                  tokubaiProjectCodeAndSalesStartDateRequests: validData.map((item) => {
                      return {
                          tokubaiProjectCode: item.tokubaiProjectCode,
                          salesStartDate: item.startDate,
                      };
                  }),
                  changeRequestType: changeRequestType,
              });

        // 削除処理
        deleteRequest
            .then(() => {
                setState((prevState) => ({
                    ...prevState,
                    selectedData: [],
                    apiResponse: null,
                    isLoad: true,
                }));
                if (hasExpired) {
                    dispatch(setToastsWarning('期限切れの売価以外が削除されました。'));
                } else {
                    dispatch(setToastsSuccess('削除が完了しました。'));
                }
            })
            .catch((error) => {
                apiErrorHandler(dispatch, error, t('message.error.delete'));
            })
            .finally(() => {
                handleChangeState('isDelete', false);
                dispatch(setDeleteConfirm(false));
                dispatch(setLoader(false));
            });
    };

    useEffect(() => {
        if (!isDelete && apiResponse === null && isLoad) {
            setState((prevState) => ({
                ...prevState,
                isLoad: false,
            }));
            getChangeRequestsApproved(page);
        }
    }, [isDelete]);

    const setDataTable = (data) => {
        setState((prevState) => ({
            ...prevState,
            apiResponse: {
                ...state.apiResponse,
                data,
            },
        }));
    };

    /**
     * 継続登録入力フォームバリデーション
     */
    const validateFormInput = () => {
        const formatSelectedStartDate = new Date(selectedStartDate);
        const formatSelectedEndDate = new Date(selectedEndDate);

        // 開始日
        if (formatSelectedStartDate < minStartDate) {
            dispatch(setToastsError('開始日は本日以降の日付を選択してください。'));
            return true;
        } else if (formatSelectedStartDate > maxStartDate) {
            dispatch(setToastsError('開始日は本日から2日以内の日付を選択してください。'));
            return true;
        }

        // 終了日
        if (formatSelectedEndDate < minEndDate) {
            dispatch(setToastsError('終了日は開始日以降の日付を選択してください。'));
            return true;
        } else if (formatSelectedEndDate > maxEndDate) {
            dispatch(setToastsError('終了日は開始日から2週間以内の日付を選択してください。'));
            return true;
        }
        return false;
    };

    return (
        <>
            <div className="okc-inner">
                <Card handleSubmit={() => getChangeRequestsApproved(1)} handleClear={handleClear}>
                    {isHeadquarter ? (
                        <>
                            <Label
                                type="column"
                                text={t('update_competitor_master.search_form.ok_store.text')}
                                className="col-lg-2 mb-2 mb-lg-4"
                                isEitherOneRequired={true}
                            />
                            <div className="col-lg-4 pr-lg-3 mb-4">
                                <SelectSearch
                                    onChange={(option) => handleChangeState('storeCode', option.value)}
                                    options={createStoreOptions(stores)}
                                    value={storeCode}
                                    placeholder={t('price_request.oke_store_name.placeholder')}
                                />
                            </div>
                        </>
                    ) : (
                        <>
                            <Label
                                type="column"
                                text={t('approved_registration_price.search_form.jan.title')}
                                className="col-lg-2 mb-2 mb-lg-4"
                            />
                            <div className="col-lg-4 pr-lg-3 mb-4">
                                <Input
                                    className="form-control form-control--input"
                                    type="text"
                                    value={jan}
                                    maxLength="16"
                                    placeholder={t('approved_registration_price.search_form.jan.placeholder')}
                                    autocomplete="off"
                                    onChange={(value) => {
                                        handleChangeState('jan', value);
                                    }}
                                />
                            </div>
                        </>
                    )}
                    <Label
                        type="column"
                        text={t('approved_registration_price.search_form.division_name.title')}
                        className="col-lg-2 pl-lg-3 mb-2 mb-lg-4"
                    />
                    <div className="col-lg-4 mb-4">
                        <SelectSearch
                            isClearable={true}
                            options={departments}
                            placeholder={t('prohibited_product_list.search_form.division.placeholder')}
                            onChange={(value) => handleChangeState('selectedDepartment', value)}
                            value={selectedDepartment?.value}
                        />
                    </div>
                    {isHeadquarter ? (
                        <>
                            <Label
                                type="column"
                                text={t('approved_registration_price.search_form.jan.title')}
                                className="col-lg-2 mb-2 mb-lg-4"
                                isEitherOneRequired={true}
                            />
                            <div className="col-lg-4 pr-lg-3 mb-4">
                                <Input
                                    className="form-control form-control--input"
                                    type="text"
                                    value={jan}
                                    maxLength="16"
                                    placeholder={t('approved_registration_price.search_form.jan.placeholder')}
                                    autocomplete="off"
                                    onChange={(value) => {
                                        handleChangeState('jan', value);
                                    }}
                                />
                            </div>
                        </>
                    ) : (
                        <>
                            <Label
                                type="column"
                                text={t('freshness.approved_registration_price.search_form.start_date.title')}
                                className="col-lg-2 mb-2 mb-lg-4"
                            />
                            <div className="col-lg-4 pr-lg-3 mb-4">
                                <ReactCalender
                                    value={startDate}
                                    onChange={(value) => {
                                        handleChangeState('startDate', value);
                                    }}
                                    classNameInputDateTime="text-left"
                                />
                            </div>
                        </>
                    )}
                    <Label
                        type="column"
                        text={t('approved_registration_price.search_form.line_name.title')}
                        className="col-lg-2 pl-lg-3 mb-2 mb-lg-4"
                    />
                    <div className="col-lg-4 mb-4">
                        <SelectSearch
                            isClearable={true}
                            options={lines}
                            placeholder={t('price_registration.search_form.line_name.placeholder')}
                            onChange={(value) => handleChangeState('selectedLine', value)}
                            value={selectedLine?.value}
                            disabled={!selectedDepartment || !lines.length}
                        />
                    </div>
                    {isHeadquarter ? (
                        <>
                            <Label
                                type="column"
                                text={t('freshness.approved_registration_price.search_form.start_date.title')}
                                className="col-lg-2 mb-2 mb-lg-4"
                            />
                            <div className="col-lg-4 pr-lg-3 mb-4">
                                <ReactCalender
                                    value={startDate}
                                    onChange={(value) => {
                                        handleChangeState('startDate', value);
                                    }}
                                    classNameInputDateTime="text-left"
                                />
                            </div>
                        </>
                    ) : (
                        <>
                            <Label
                                type="column"
                                text={t('freshness.approved_registration_price.search_form.end_date.title')}
                                className="col-lg-2 mb-2 mb-lg-4"
                            />
                            <div className="col-lg-4 pr-lg-3 mb-4">
                                <ReactCalender
                                    value={endDate}
                                    onChange={(value) => {
                                        handleChangeState('endDate', value);
                                    }}
                                    classNameInputDateTime="text-left"
                                    minDate={new Date(new Date().setDate(new Date().getDate() - 15))}
                                />
                            </div>
                        </>
                    )}
                    <Label
                        type="column"
                        text={t('approved_registration_price.search_form.class_name.title')}
                        className="col-lg-2 pl-lg-3 mb-2 mb-lg-4"
                    />
                    <div className="col-lg-4 mb-4">
                        <SelectSearch
                            isClearable={true}
                            options={classes}
                            placeholder={t('price_registration.search_form.class_name.placeholder')}
                            onChange={(value) => handleChangeState('selectedClass', value)}
                            value={selectedClass?.value}
                            disabled={!selectedLine || !classes.length}
                        />
                    </div>
                    {isHeadquarter ? (
                        <>
                            <Label
                                type="column"
                                text={t('freshness.approved_registration_price.search_form.end_date.title')}
                                className="col-lg-2 mb-2 mb-lg-4"
                            />
                            <div className="col-lg-4 pr-lg-3 mb-4">
                                <ReactCalender
                                    value={endDate}
                                    onChange={(value) => {
                                        handleChangeState('endDate', value);
                                    }}
                                    classNameInputDateTime="text-left"
                                    minDate={new Date(new Date().setDate(new Date().getDate() - 15))}
                                />
                            </div>
                        </>
                    ) : (
                        <>
                            {!isFreshness && (
                                <>
                                    <Label
                                        type="column"
                                        text={t('approved_registration_price.search_form.competitor_chain.title')}
                                        className="col-lg-2 mb-2 mb-lg-4"
                                    />
                                    <div className="col-lg-4 pr-lg-3 mb-4">
                                        <MultiSelect
                                            placeholder={t('export_summary.competitive_chain.placeholder')}
                                            onChange={(option, codes) => {
                                                handleChangeMultiState('competitorChainCode', option);
                                                handleChangeMultiState('competitorChainCodes', codes);
                                                handleChainChange(option, codes);
                                            }}
                                            options={createCompetitorChainOptions(competitorChains)}
                                            value={competitorChainCode}
                                        />
                                    </div>
                                </>
                            )}
                            {isFreshness && <div className="col-lg-6"></div>}
                        </>
                    )}
                    <Label
                        type="column"
                        text={t('approved_registration_price.search_form.subclass_name.title')}
                        className="col-lg-2 pl-lg-3 mb-2 mb-lg-4"
                    />
                    <div className="col-lg-4 mb-4">
                        <SelectSearch
                            isClearable={true}
                            options={subclasses}
                            placeholder={t('price_registration.search_form.subclass_name.placeholder')}
                            onChange={(value) => handleChangeState('selectedSubclass', value)}
                            value={selectedSubclass?.value}
                            disabled={!selectedClass || !subclasses.length}
                        />
                    </div>
                    {isHeadquarter ? (
                        <>
                            {!isFreshness && (
                                <>
                                    <Label
                                        type="column"
                                        text={t('approved_registration_price.search_form.competitor_chain.title')}
                                        className="col-lg-2 mb-2 mb-lg-4"
                                    />
                                    <div className="col-lg-4 pr-lg-3 mb-4">
                                        <MultiSelect
                                            placeholder={t('export_summary.competitive_chain.placeholder')}
                                            onChange={(option, codes) => {
                                                handleChangeMultiState('competitorChainCode', option);
                                                handleChangeMultiState('competitorChainCodes', codes);
                                                handleChainChange(option, codes);
                                            }}
                                            options={createCompetitorChainOptions(competitorChains)}
                                            value={competitorChainCode}
                                        />
                                    </div>
                                </>
                            )}
                            {isFreshness && <div className="col-lg-6"></div>}
                        </>
                    ) : (
                        <div className="col-lg-6"></div>
                    )}
                    {!isFreshness && (
                        <>
                            <Label
                                type="column"
                                text={t('approved_registration_price.search_form.competitor_store.title')}
                                className="col-lg-2 pl-lg-3 mb-2 mb-lg-4"
                                style={{ height: '40px' }}
                            />
                            <div className="col-lg-4 mb-4">
                                <MultiSelect
                                    placeholder={t('export_summary.competitive_store.placeholder')}
                                    onChange={(option, codes) => {
                                        handleChangeMultiState('competitorStoreCode', option);
                                        handleChangeMultiState('competitorStoreCodes', codes);
                                    }}
                                    options={filteredChildOptions}
                                    value={competitorStoreCode}
                                    disabled={!competitorChainCode.length}
                                />
                            </div>
                        </>
                    )}
                    {isHeadquarter && <EitherOneRequiredText />}
                </Card>
                <Pagination pageCount={apiResponse?.totalPage} onPageChange={handlePageClick} page={page} />
                <div className="tab-pane show active">
                    <EditTable
                        isHeightTr
                        confirmStatus="CONFIRMED"
                        isSearched={!isSearched}
                        heads={table.heads}
                        body={table.body}
                        dataTable={apiResponse?.data}
                        setDataTable={setDataTable}
                        pagination={paginate}
                        setSelectedData={handleSetSelectedData}
                        discounts={discounts}
                    />
                    <div className="okc-delete d-flex justify-content-between mb-5">
                        <div className="d-flex okc-pagination-bottom">
                            <Pagination pageCount={apiResponse?.totalPage} onPageChange={handlePageClick} page={page} />
                        </div>
                        <div className="okc-pagination-bottom-btn">
                            {isCompetitor && (
                                <Button className="btn btn--primary upload-registration__submit" onClick={handleContinuationRegister}>
                                    <span className="btn-text">継続登録</span>
                                </Button>
                            )}
                            {!isInstruction && !isHead && (
                                <Button className="btn btn--primary upload-registration__submit ml-3" onClick={handleDelete}>
                                    <span className="btn-text">削除</span>
                                </Button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {!isFreshness && (
                <Modal
                    size="sm"
                    type="please_select_checkbox"
                    isShow={isShowPleaseSelect}
                    onClose={handleCloseModal}
                    isShowIconClose="true"
                    title={t('approved_registration_price.modal.continue_registration.title')}
                    btnList={[
                        {
                            name: t('button.OK'),
                            className: 'btn--primary',
                            onClick: () => handleCloseModal(),
                            disabled: false,
                        },
                    ]}
                >
                    <p className="text-center">{t('approved_registration_price.modal.continue_registration.body.text_03')}</p>
                </Modal>
            )}
            <Modal
                size="sm"
                type="please_select_checkbox"
                isShow={isShowPleaseDeleteSelect}
                onClose={handleCloseModal}
                isShowIconClose="true"
                title="選択した商品のデータを削除します。"
                btnList={[
                    {
                        name: t('button.OK'),
                        className: 'btn--primary',
                        onClick: () => handleCloseModal(),
                        disabled: false,
                    },
                ]}
            >
                <p className="text-center">削除するデータを選択してください。</p>
            </Modal>
            <Modal
                size="sm"
                type="please_select_checkbox"
                isShow={isInstructionSelect}
                onClose={handleCloseModal}
                isShowIconClose="true"
                title={t('approved_registration_price.continue-registration-prohibited-modal.title')}
                btnList={[
                    {
                        name: t('button.OK'),
                        className: 'btn--primary',
                        onClick: () => handleCloseModal(),
                        disabled: false,
                    },
                ]}
            >
                <p className="text-center">{t('approved_registration_price.continue-registration-prohibited-modal.body.text01')}</p>
                <p className="text-center">{t('approved_registration_price.continue-registration-prohibited-modal.body.text02')}</p>
            </Modal>
            <Modal
                size="sm"
                isShow={isShowModalApprove}
                onClose={handleCloseModalApprove}
                isShowIconClose="true"
                title={'選択した商品を継続登録します。'}
                className="registration-edit-modal"
                btnList={[
                    {
                        name: t('approved_registration_price.modal.continue_registration.footer.button.continue'),
                        className: 'btn--primary',
                        onClick: () => handleSubmitModalApprove(),
                        disabled: !selectedSource || !selectedStartDate || !selectedEndDate || !authorizerName,
                    },
                    {
                        name: t('approved_registration_price.modal.continue_registration.footer.button.cancel'),
                        className: 'btn--secondary',
                        onClick: () => handleCloseModalApprove(),
                        disabled: false,
                    },
                ]}
            >
                <p className="text-center">{t('approved_registration_price.modal.continue_registration.body.text_01')}</p>
                <p className="text-center">情報取得元、開始日、終了日、承認者名を入力してください。</p>
                <div className="approval-source">
                    <Choice
                        id="source"
                        column="col-xl-3 col-lg-4 col-md-5"
                        type="radio"
                        data={sources}
                        onChange={(value) => handleChangeState('selectedSource', value[0])}
                        checked={[selectedSource]}
                    />
                </div>
                <div className="approval-date">
                    <ReactCalender
                        value={selectedStartDate}
                        onChange={(value) => handleChangeState('selectedStartDate', value)}
                        classNameInputDateTime="text-center"
                        minDate={minStartDate}
                        maxDate={maxStartDate}
                    />
                    <span className="approval-date__tilde">〜</span>
                    <ReactCalender
                        value={selectedEndDate}
                        onChange={(value) => handleChangeState('selectedEndDate', value)}
                        classNameInputDateTime="text-center"
                        minDate={minEndDate}
                        maxDate={maxEndDate}
                    />
                </div>
                <div className="approval-name">
                    <Input
                        className="form-control form-control--input"
                        name="authorizerName"
                        type="text"
                        autocomplete="off"
                        maxLength="45"
                        placeholder={t('confirm_registration_price.modal_confirm_deleted_csv.approval_name.label')}
                        value={authorizerName}
                        onChange={(value) => handleChangeState('authorizerName', value)}
                    />
                </div>
            </Modal>

            {/* 重複確認モーダル */}
            {duplicateModalIsShow && <DuplicateModal {...duplicateModalProps} />}
        </>
    );
};

export default ChangeRequestApproved;
